// extracted by mini-css-extract-plugin
export var infoRow = "_sp-2";
export var labelContainer = "_sp-0";
export var rightInfo = "_sp-1";